/* eslint-disable react-hooks/exhaustive-deps */

import { useCallback } from 'react';
import { Watchlist } from '../types';
import useLog from './useLog';

const useWatchlists = () => {
  const { fetchAPIWithLog } = useLog('useWatchlists');

  const saveWatchlists = useCallback(
    async (watchlists: Watchlist[], deletes: number[]) => {
      const body = JSON.stringify({ watchlists, deletes });
      const postOpts = { method: 'POST', body };
      return await fetchAPIWithLog<Watchlist[]>('v1/me/watchlists', postOpts);
    },
    [],
  );

  return { saveWatchlists };
};

export default useWatchlists;
